module.exports = __webpack_public_path__ + "static/Roboto-Light-88823c2015ffd5fa89d567e17297a137.ttf";